import axios from 'axios';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = window.location.hostname;
  const port = window.location.port;
  if (!port || port === '80') {
    return '/genetics/api/v1';
  }
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `${window.location.protocol}//${hostname}:8000/api/v1`;
  }
  return 'http://localhost:8000/api/v1';
};

const API_BASE_URL = getApiBaseUrl();
const normalizedBaseUrl = API_BASE_URL.endsWith('/')
  ? API_BASE_URL.slice(0, -1)
  : API_BASE_URL;

const api = axios.create({
  baseURL: normalizedBaseUrl,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export const searchGenes = async (query, limit = 50) => {
  const response = await api.get('/genes/search', { params: { query, limit } });
  return response.data;
};

export const getGeneDetails = async (geneIdentifier) => {
  const response = await api.get(`/genes/${geneIdentifier}`);
  return response.data;
};

export const getExportUrl = (geneSymbol) => {
  return `${normalizedBaseUrl}/genes/${geneSymbol}/export?format=csv`;
};

export const getTopGenes = async (disorder, limit = 100, subtype = null) => {
  const params = { disorder, limit };
  if (subtype) params.subtype = subtype;
  const response = await api.get('/genes/top/genes', { params });
  return response.data;
};

export const getAvailableSubtypes = async (disorder) => {
  const response = await api.get('/genes/top/genes/subtypes', { params: { disorder } });
  return response.data;
};

export const getSummaryStats = async () => {
  const response = await api.get('/stats/summary');
  return response.data;
};

export const getMetaAnalysis = async (limit = 100) => {
  const response = await api.get('/genes/meta-analysis', { params: { limit } });
  return response.data;
};

export const getPleiotropySummary = async (geneIdentifier) => {
  const response = await api.get(`/pleiotropy/summary/${geneIdentifier}`);
  return response.data;
};

export default api;
